import React, { useState, useContext } from "react";
import { Card, CardHeader, Icon, styled } from "@mui/material";
import AccountingApi from "Classes/API/AccountingApi";
import CreatePackageReq from "Classes/Models/Requests/AccountingSessions/CreatePackageReq";
import Loader from "Loader";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DatePicker from "components/DatePicker";

import { LanguageContext } from "App";

const AccSessionPackageStats = () => {
  const [loading, setLoading] = useState(false);

  const [totalPackages, SetTotalPackages] = useState(0);
  const [totalOrginalPrice, SetTotalOrginalPrice] = useState(0);
  const [totalFinalPrice, SetTotalFinalPrice] = useState(0);
  const [totalAmountPaid, SetTotalAmountPaid] = useState(0);
  const [totalAmountDiscounted, SetTotalAmountDiscounted] = useState(0);
  const [totalAverageAmountDiscounted, SetTotalAverageAmountDiscounted] = useState(0);
  const [totalAmountUsed, SetTotalAmountUsed] = useState(0);
  const [TotalDiscountedAmountUsed, SetTotalDiscountedAmountUsed] = useState(0);
  const [totalRefundableAmount, SetTotalRefundableAmount] = useState(0);
  const [totalAmountDue, SetTotalAmountDue] = useState(0);
  const [totalPostpaidAmount, SetTotalPostpaidAmount] = useState(0);
  const [totalPostPaidAmountUsed, SetTotalPostPaidAmountUsed] = useState(0);
  const [totalPostPaidAmountDue, SetTotalPostPaidAmountDue] = useState(0);

  const [fromDate, SetFromDate] = useState(null);
  const [toDate, SetToDate] = useState(null);
  const { translations } = useContext(LanguageContext);

  const CustomCardHeader = styled(CardHeader)(({ theme }) => ({
    "& .MuiCardHeader-title": {
      color: "white",
      textAlign: "center",
      width: "100%",
    },
  }));

  const clearFilter = async () => {
    SetFromDate(null);
    SetToDate(null);
  };

  const UpdateStats = async (data) => {
    console.log(data);
    SetTotalPackages(data.totalPackages);
    SetTotalOrginalPrice(data.totalOrginalPrice);
    SetTotalFinalPrice(data.totalFinalPrice);
    SetTotalAmountPaid(data.totalAmountPaid);
    SetTotalAmountDiscounted(data.totalAmountDiscounted);
    SetTotalAverageAmountDiscounted(data.totalAverageAmountDiscounted);
    SetTotalAmountUsed(data.totalAmountUsed);
    SetTotalDiscountedAmountUsed(data.totalDiscountedAmountUsed);
    SetTotalRefundableAmount(data.totalRefundableAmount);
    SetTotalAmountDue(data.totalAmountDue);
    SetTotalPostpaidAmount(data.totalPostpaidAmount);
    SetTotalPostPaidAmountUsed(data.totalPostPaidAmountUsed);
    SetTotalPostPaidAmountDue(data.totalPostPaidAmountDue);
  };

  const fetchPackagesStats = async () => {
    console.log(fromDate, "  ", toDate);
    try {
      if (!loading) {
        setLoading(true);
      }
      let req = new CreatePackageReq();
      if (fromDate != null) {
        req.fromDate = fromDate;
      }
      if (toDate != null) {
        req.toDate = toDate;
      }

      const res = await AccountingApi.GetPackagesStatistics(req);
      if (res && res.status === "Success") {
        UpdateStats(res.data);
      } else {
        console.error('Error: API response status not "Success"');
      }
    } catch (error) {
      console.error("Error fetching Packagess Stats:", error);
    } finally {
      setLoading(false);
    }

    //     console.log("Appday: ", req)
    //     req.SearchDate = new Date(state.AppDay.dateDay);
    //     req.SearchDate.setHours(12, 0, 0, 0);
    //     req.DayId = state.AppDay.id
    //     req.TherapistId = Therapist?.id
    //     req.PatientId = Patient?.id
    //     req.pagingParams.pageNumber = Page;
    //     req.pagingParams.pageSize = 10;

    //     const res = await AccountingApi.FindAccountingSessionPatientEnteries(req);
    //     console.log("res", res);
    //     if (res && res.status === "Success") {
    //         const list = res.data?.list ?? [];
    //         RefreshTable(list);
    //         setPaginationPages(res.data?.totalPages ?? 0);
    //     } else {
    //         console.error('Error: API response status not "Success"');
    //         setPaginationPages(0);
    //     }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card mb={3} id="SearchPackagesStats">
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.StasticsFeedbackFilterPackagesby}
          </MDTypography>
          <MDButton
            onClick={() => clearFilter()}
            sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
            color="info"
          >
            <Icon sx={{ fontWeight: "bold" }}>search</Icon>
            &nbsp;{translations.StasticsFeedbackClearFilters}
          </MDButton>
        </MDBox>

        <form id="SearchPackagesStatsForm">
          <MDBox p={3}>
            <MDBox
              borderRadius="lg"
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              p={2}
            >
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-4 ">
                    <DatePicker
                      onChange={SetFromDate}
                      selected={fromDate}
                      placeholderText={translations.StasticsFeedbackStartDate}
                    />
                  </div>
                  <div className="col-md-4 ">
                    <DatePicker
                      onChange={SetToDate}
                      selected={toDate}
                      placeholderText={translations.StasticsFeedbackEndDate}
                    />
                  </div>
                  <div className="col-md-4 align-content-center">
                    <MDButton
                      onClick={() => fetchPackagesStats()}
                      sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                      color="info"
                    >
                      <Icon sx={{ fontWeight: "bold" }}>search</Icon>
                      &nbsp;{translations.StasticsFeedbackGetStatistics}
                    </MDButton>
                  </div>
                </div>
              </div>
            </MDBox>
          </MDBox>
        </form>
      </Card>
      {loading ? (
        <Loader type="balls" color="black" />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalPackages} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalPackages}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalOriginalPrice} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalOrginalPrice}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalFinalPrice} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalFinalPrice}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalAmountPaid} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalAmountPaid}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalAmountDiscounted} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalAmountDiscounted}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackAverageAmountDiscounted} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalAverageAmountDiscounted}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalAmountUsed} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalAmountUsed}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalDiscountedAmountUsed} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {TotalDiscountedAmountUsed}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalRefundableAmount} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalRefundableAmount}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalAmountRemaining} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalAmountDue}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalPostPaidAmount} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalPostpaidAmount}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalPostPaidAmountUsed} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalPostPaidAmountUsed}
                </MDBox>
              </Card>
            </div>
            <div className="col-md-4">
              <Card sx={{ padding: "1em", margin: "1em 0 0 0", backgroundColor: "#3560AD" }}>
                <CustomCardHeader title={translations.StasticsFeedbackTotalPostPaidAmountDue} />
                <MDBox
                  mb={3}
                  sx={{ display: "flex", justifyContent: "space-around", color: "#ffffff" }}
                >
                  {totalPostPaidAmountDue}
                </MDBox>
              </Card>
            </div>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
};

export default AccSessionPackageStats;
